import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { ActionCreators } from "../../_actions/ActionCreators";
import LojaService from "../../services/LojaService";
import ModalConfirmação from "../FlexFreteModal/ModalConfirmacao";
import Modal from "../FlexFreteModal/Modal";
import FlexSpinner from "../FlexFreteSpinner/FlexSpinner";
import { cnpjMask } from "../../utils/Masks";
import { LojaCardStyle } from "./style";

const lojaService = new LojaService();

function Loja(props) {
  const history = useHistory();
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [isLojaAtiva] = useState(props.item.ativo);
  const [showConfirmaExcluir, setShowConfirmaExcluir] = useState(false);

  const [erroExcluir, setErroExcluir] = useState(false);

  const excluirLoja = () => {
    setIsLoading(true);
    lojaService.deleteLoja(props.item.uuid, (err) => {
      setIsLoading(false);
      if (err) {
        setErroExcluir(true);
        setShowConfirmaExcluir(false);
      } else {
        props.onExcluir(props.item.uuid);
      }
    });
  };

  useEffect(() => {
    setShowConfirmaExcluir(false);
  }, [isLojaAtiva]);

  const onClickEditarLoja = () => {
    dispatch(ActionCreators.showModal(false));
    history.push(`/configuracoes/loja/editar/${props.item.uuid}`, { res: props.item });
  };

  const toggleShowConfirmaExcluir = () => {
    setShowConfirmaExcluir(!showConfirmaExcluir);
  };

  const nomeCnpj = props.item.cnpj
    ? `${props.item.razaoSocial} - ${cnpjMask(props.item.cnpj)}`
    : props.item.razaoSocial;

  const enderecoFormatado = () => {
    const { endereco } = props.item;
    if (!endereco?.logradouro) return null;
    const cidade = endereco.nomeCidade || "";
    const rua = endereco.logradouro;
    const numero = endereco.numero ? `, ${endereco.numero}` : "";
    const complemento = endereco.complemento ? `, ${endereco.complemento}` : "";
    return cidade ? `${cidade} - ${rua}${numero}${complemento}` : `${rua}${numero}${complemento}`;
  };

  return (
    <>
      {isLoading ? <FlexSpinner /> : ""}
      {erroExcluir ? (
        <Modal
          callbackModal={() => setErroExcluir(false)}
          visivel={true}
          titulo="Erro ao excluir loja"
          conteudo="Não foi possível desativar a loja. Tente novamente."
        />
      ) : null}
      {showConfirmaExcluir ? (
        <ModalConfirmação
          onClickRecusa={toggleShowConfirmaExcluir}
          onClickConfirma={excluirLoja}
          visivel={true}
          titulo="Excluir a loja"
          conteudo="Tem certeza que deseja excluir a loja?"
        />
      ) : null}

      <div className="column is-half column-doc-gap">
        <LojaCardStyle isPadrao={props.isPadrao}>
          {props.isPadrao === true ? (
            <h2 className="ePadrao">
              <ion-icon name="checkmark-circle-outline"></ion-icon> Loja Padrão
            </h2>
          ) : null}

          <h2 className="nomeDaLoja">{nomeCnpj}</h2>

          {enderecoFormatado() ? <p className="enderecoLoja">{enderecoFormatado()}</p> : null}

          <div className={`status-loja ${isLojaAtiva ? "ativa" : "desativada"}`}>
            {isLojaAtiva ? (
              <>
                <ion-icon name="checkmark-circle-outline"></ion-icon>
                <span>Ativa</span>
              </>
            ) : (
              <>
                <ion-icon name="alert-circle"></ion-icon>
                <span>Desativada</span>
              </>
            )}
          </div>

          <button onClick={onClickEditarLoja} className="button btn-principal">
            Editar
          </button>

          <button onClick={toggleShowConfirmaExcluir} className="button btn-secundario">
            Excluir
          </button>
        </LojaCardStyle>
      </div>
    </>
  );
}

export default Loja;
